const pushReportApiPrefix = accountId => `/${accountId}/push-api-subscriptions`;
const pushApiResourcePrefix = '/authenticated-resources/push-api';
const pushApiResourcePrefixFieldTypes = pushApiResourcePrefix + '/entity-types';

export const pushReportApiFactory = ({ callPutApi, callPostApi, callDeleteApi, callGetApi }) => ({
    getPushApiEntityTypes: () => callGetApi(`${pushApiResourcePrefix}/entity-types`),
    getPushApiFieldTypes: entityType => callGetApi(`${pushApiResourcePrefixFieldTypes}/field-types/${entityType}`),

    getPushReport: (accountId, reportId) => callGetApi(`${pushReportApiPrefix(accountId)}/${reportId}`),
    createPushReport: (accountId, report) => callPostApi(`${pushReportApiPrefix(accountId)}`, report),
    deletePushReport: (accountId, reportId) => callDeleteApi(`${pushReportApiPrefix(accountId)}/${reportId}`),
    updatePushReport: (accountId, reportId, report) =>
        callPutApi(`${pushReportApiPrefix(accountId)}/${reportId}`, report),
});
